import { render, staticRenderFns } from "./Account_Receivables_Detail.vue?vue&type=template&id=1f8650d1"
import script from "./Account_Receivables_Detail.vue?vue&type=script&lang=js"
export * from "./Account_Receivables_Detail.vue?vue&type=script&lang=js"
import style0 from "./Account_Receivables_Detail.vue?vue&type=style&index=0&id=1f8650d1&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports